import React, { useContext } from 'react';
import { HELP_DESK_PRIORITY_LABEL_KEYS } from '@ubeya/shared/constants/helpDesk';
import { FlexMiddle } from '../../Flex';
import ConfigContext from '../../../contexts/ConfigContext';

const HelpDeskPriorityChip = ({ value }) => {
  const { t } = useContext(ConfigContext);
  const items = value ? (Array.isArray(value) ? value : [value]) : [];
  if (!items.length) return null;
  if (items.length > 1) return <FlexMiddle>{t('help_desk_n_priorities', { count: items.length })}</FlexMiddle>;
  const key = items[0]?.priority || items[0];
  return <FlexMiddle>{t(HELP_DESK_PRIORITY_LABEL_KEYS[key] || HELP_DESK_PRIORITY_LABEL_KEYS.NONE)}</FlexMiddle>;
};

export default HelpDeskPriorityChip;
